<mat-card class="detail-card" valumizeCardContextMenu context="/funds/overview/">
    @let params = params$ | async;
    @if ((mergeError$ | async); as mergeError) {
        @if (mergeError.statusCode) {
            <valumize-info-panel [appearance]="'ERROR'" [message]="mergeError.errorMessage"></valumize-info-panel>
        }
    }
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">Fund Overview</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
        <div class="table-toolbar">
            <mat-checkbox color="primary" [(ngModel)]="showArchived" (change)="onArchivedChanged($event)">
                Show Archived
            </mat-checkbox>
            <span class="spacer"></span>
            @if (selectMode) {
                <span class="bulk-action-count">{{ selection.selected.length }} selected</span>
                @if (showArchived) {
                    <button mat-stroked-button (click)="archiveSelected(false)">
                        <mat-icon>unarchive</mat-icon>
                        Unarchive
                    </button>
                } @else {
                    <button mat-stroked-button color="primary" (click)="archiveSelected(true)">
                        <mat-icon>archive</mat-icon>
                        Archive
                    </button>
                }
                <button mat-button (click)="exitSelectMode()">Clear</button>
            }
            @if (searchVisible) {
                <input matInput #searchInput id="search-input" class="list-search-input" (input)="onSearchInput($event)" placeholder="Search">
            }
            <valumize-card-comments-button context="/funds/overview/"></valumize-card-comments-button>
            <button mat-icon-button (click)="toggleSearch()" matTooltip="Search">
                <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button (click)="openTableSettings()" matTooltip="Table Settings">
                <mat-icon>view_column</mat-icon>
            </button>
        </div>

        <div class="table-container">
            @if (isLoading$ | async) {
                <div class="loading-overlay">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
            }

            <table mat-table [dataSource]="(funds$ | async) ?? []" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortActive" [matSortDirection]="sortDirection">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                        <mat-checkbox color="primary"
                                      (change)="selection.toggle(element)"
                                      [checked]="selection.isSelected(element)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fundId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
                    <td mat-cell *matCellDef="let element">{{element.id}}</td>
                </ng-container>

                <ng-container matColumnDef="fundName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Fund</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.isArchived?.value) {
                            <mat-icon class="archived-icon">inventory_2</mat-icon>
                        }
                        {{element.name | traceableFormat}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="country">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="country">Country</th>
                    <td mat-cell *matCellDef="let element">{{element.country.code | codeFormat: codeTableCountry | async}}</td>
                </ng-container>

                <ng-container matColumnDef="currencyIso">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="currencyIso">Currency</th>
                    <td mat-cell *matCellDef="let element">{{element.currencyIso.code | codeFormat: codeTableCurrency | async}}</td>
                </ng-container>

                <ng-container matColumnDef="size">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="size">This Fund Size</th>
                    <td mat-cell *matCellDef="let element">{{element.size | traceableFormat}}</td>
                </ng-container>

                <ng-container matColumnDef="mainFundSize">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="mainFundSize">Main Fund Size</th>
                    <td mat-cell *matCellDef="let element">{{element.mainFundSize | traceableFormat}}</td>
                </ng-container>

                <ng-container matColumnDef="vintageYear">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="vintageYear">Vintage Year</th>
                    <td mat-cell *matCellDef="let element">{{element.vintageYear | traceableFormat}}</td>
                </ng-container>

                <ng-container matColumnDef="endYear">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="endYear">Fund Ends</th>
                    <td mat-cell *matCellDef="let element">{{element.endYear | traceableFormat}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [routerLink]="selectMode ? null : row.id"
                    (contextmenu)="onRowContextMenu($event, row)"></tr>
            </table>
        </div>

        <valumize-context-menu #ctxMenu></valumize-context-menu>

        @if (params) {
            <mat-paginator
                [length]="(totalElements$ | async) ?? 0"
                [pageIndex]="params.page"
                [pageSize]="params.size"
                [pageSizeOptions]="[10, 20, 30, 50, 100]"
                showFirstLastButtons
                (page)="onPageChange($event)">
            </mat-paginator>
        }
    </mat-card-content>
    <mat-card-actions class="overview-actions">
        <button mat-stroked-button color="primary" (click)="openNewFundDialog()" data-test="new-fund">
            <mat-icon>add</mat-icon>
            Fund
        </button>
    </mat-card-actions>
</mat-card>
